import React from 'react';
import { Redirect } from 'react-router-dom';
// COMPONENTS
import ContractPageHeader from 'components/common/ContractPageHeader';
// LIB
import RecomposeHelpers from 'lib/helpers/RecomposeHelpers';
// APOLLO
import { compose, graphql } from 'react-apollo';
import contractByIdQuery from 'ApolloClient/Queries/contractById';
// ANTD

import SignedPDF from './SignedPDF';
import moment from 'moment';

const DEFAULT_SALES_TAX = 2;
const DEFAULT_LINE_ITEM = {
  description: '',
  amount: 0,
};

const INITIAL_STATE = {
  keys: [],
  discountType: 'dollar-amount', // 'dollar-amount' or 'percentage'
  contractType: 'Portrait', // 'Portrait', etc
  sessionDate: moment(),
  currency: 'USD',
  finalPaymentAmount: 0,
  finalPaymentDueDate: moment(),
  // createInvoices
  createInvoices: 'dont-create',
  // discount
  discountValue: 0, // discountValue is the percentage or dollar amount of discount
  discountAmount: 0, // discountAmount is based on the discountValue and discountType... dicountValue may be a percentage or a dollar amount... depending on dicountType.
  // deposit
  depositValue: 0,
  depositAmount: 0,
  depositDueDate: moment(),
  depositType: 'dollar-amount', // 'dollar-amount' or 'percentage',
  //
  totalWithTax: DEFAULT_LINE_ITEM.amount * (DEFAULT_SALES_TAX / 100),
  salesTax: DEFAULT_SALES_TAX,
  total: DEFAULT_LINE_ITEM.amount,
  taxAmount: 0,
  subtotalAfterTax: 0,
  subtotal: 0,
  // SIGNATURE
  contractorSignature: null,
  contractorSignDate: null,
  contractorEmail: null,
  clientSignature: null,
  clientSignDate: null,
  clientEmail: null,
};

class ContractView extends React.PureComponent {
  state = {
    step: 1,
    contract: {
      ...INITIAL_STATE,
    },
    sendModalVisible: false,
  };

  componentDidMount() {
    this.setContractState(this.props.contractByIdQuery.contractById);
  }

  setContractState = newContractValues => {
    this.setState({
      contract: {
        ...this.state.contract,
        ...newContractValues,
        clientEmail: this.props.contractByIdQuery.contractById.client.email, // only on inception do we set this as the default... use can edit it in local this.state
      },
    });
  };

  onChange = newContractValue => {
    this.setState({
      contract: {
        ...this.state.contract,
        ...newContractValue,
      },
    });
  };

  onEmailSent = () => {
    window.location.reload();
  };

  toggleSendModal = () => {
    window.location.reload();
  };

  render() {
    const { contractById } = this.props.contractByIdQuery;
    // // if this is true, the contractor is viewing and he has not signed it
    if (!contractById.contractorSignature && this.props.currentUser) {
      return <Redirect to={`/contract/sign/${contractById._id}?type=contractor`} />;
    }

    // if this is true, the client is viewing and has not signed it
    if (contractById.contractorSignature && !contractById.clientSignature && !this.props.currentUser) {
      return <Redirect to={`/contract/sign/${contractById._id}?type=client`} />;
    }

    // if this is true, neither contractoror client has signed it, so show nothing on the viewing screen
    if (!contractById.contractorSignature && !contractById.clientSignature && !this.props.currentUser) {
      return null;
    }

    console.log('this.state.contract');
    console.log(this.state.contract);

    return (
      <div style={{ width: '100%', maxWidth: '100%', height: '100%' }}>
        <ContractPageHeader current={3} currentUser={this.props.currentUser} />
        <div className="contract-step-container">
          <div style={{ flex: 5, maxWidth: '100%' }}>
            <SignedPDF
              sendModalVisible={this.state.sendModalVisible}
              toggleSendModal={this.toggleSendModal}
              onEmailSent={this.onEmailSent}
              currentUser={this.props.currentUser}
              userExists={!!(this.props.currentUser && this.props.currentUser._id)}
              onChange={this.onChange}
              contract={this.state.contract}
            />{' '}
          </div>
          <div style={{ flex: 1 }} />
        </div>
      </div>
    );
  }
}

// APOLLO OPTIONS
// ================================
let options = props => {
  let variables = {
    _id: props.match.params._id,
  };

  return {
    variables,
  };
};

// FINAL EXPORT
// ================================
export default compose(
  graphql(contractByIdQuery, { options, name: 'contractByIdQuery' }),
  RecomposeHelpers.errorHOC({ propName: 'contractByIdQuery' }),
  RecomposeHelpers.loadingHOC({ propName: 'contractByIdQuery' }),
)(ContractView);



// WEBPACK FOOTER //
// ./src/routes/contract-view/index.js